import { UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './index.css';

interface IModalRowProps {
  label: string;
  name?: string;
  align?: 'center';
}

export const ModalRow: React.FC<React.PropsWithChildren<IModalRowProps>> = ({ children, label, name, align }) => (
  <div className={styles['row']} style={{ alignItems: align }} data-name={name}>
    <div className={styles['row-label']}>
      <UIHeading5>{label}</UIHeading5>
    </div>
    {children}
  </div>
);
